import type { IMenuItem } from '@/shared/config/menu';
import type { PageAccess } from '@/entities/Administration';
import { isPathAllowed } from './pathnamePageAccess';

export function filterMenuByPageAccess(menu: IMenuItem[], pageAccess: PageAccess | null): IMenuItem[] {
  if (!pageAccess) return [];

  return menu
    .map((item) => {
      if (item.children?.length) {
        const children = item.children.filter((ch) => ch.href && isPathAllowed(ch.href, pageAccess));
        if (children.length === 0) return null;
        return { ...item, children };
      }
      if (item.href && isPathAllowed(item.href, pageAccess)) return item;
      return null;
    })
    .filter((x): x is IMenuItem => x !== null);
}
